import { reactLegacyTemplate, reactTemplate } from "./react-templates";

export type ProjectTemplateName = "react" | "react-legacy";

export const templateLoader = async (templateName: ProjectTemplateName, entryFilePath: string) => {
  if (templateName === "react")
    return reactTemplate(entryFilePath);
  else if (templateName === "react-legacy")
    return reactLegacyTemplate(entryFilePath);
  else
    return reactTemplate(entryFilePath);
}
